module.exports = __webpack_public_path__ + "static/media/ehealth_adolescent_banner_mobile.7d110e33.png";